import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom"; 
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Pages/Home";
import About from "./Components/Pages/About";
import Course from "./Components/Pages/Course";
import Services from "./Components/Pages/Services";
import Contact from "./Components/Pages/Contactus";
import Portfolio from "./Components/Pages/Portfolio";
import Internship from "./Components/Pages/Internship";
import Blog from "./Components/Pages/Blog";
import Career from "./Components/Pages/Career";
import Fullblog from "./Components/Pages/FullBlog";
import PythonFullStack from "./Components/Pages/Courses/PythonFullStack"
import JavaFullStack from "./Components/Pages/Courses/JavaFullStack"
import MernFullStack from "./Components/Pages/Courses/MernFullStack"  
import MeanFullStack from "./Components/Pages/Courses/MeanFullStack"
import MobileAppDevelopment from "./Components/Pages/Courses/MobileAppDevelopment"
import DataAnalysis from "./Components/Pages/Courses/DataAnalysis"
import UIUXDesigning from "./Components/Pages/Courses/UIUXDesigning"
import AWSCloud from "./Components/Pages/Courses/AWSCloud"
import DevOps from "./Components/Pages/Courses/DevOps"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function LegacyBlogRedirect() {
  const { id } = useParams();
  return <Navigate replace to={`/blogs/${id}`} />;
}

function App() {
  return (
    <BrowserRouter>
      {" "}
      <div>
        <Navbar />
        <Routes>
          {" "}
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/courses" element={<Course />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contactus" element={<Contact />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/internship" element={<Internship />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/career" element={<Career />} />
          <Route path="/Career" element={<Navigate replace to="/career" />} />
          <Route path="/blogs/:id" element={<Fullblog />} />
          <Route path="/fullblog/:id" element={<LegacyBlogRedirect />} />

          <Route path="/courses/python-full-stack" element={<PythonFullStack />} />
          <Route path="/courses/java-full-stack" element={<JavaFullStack />} />
          <Route path="/courses/mern-stack" element={<MernFullStack />} />
          <Route path="/courses/mean-stack" element={<MeanFullStack />} />
          <Route path="/courses/mobile-app-development" element={<MobileAppDevelopment />} />
          <Route path="/courses/data-analysis" element={<DataAnalysis />} />
          <Route path="/courses/ui-ux-design" element={<UIUXDesigning />} />
          <Route path="/courses/aws-cloud" element={<AWSCloud />} />
          <Route path="/courses/devops" element={<DevOps />} />

          {/* Legacy course URLs */}
          <Route path="/pyhtonfullstack" element={<Navigate replace to="/courses/python-full-stack" />} />
          <Route path="/javafullstack" element={<Navigate replace to="/courses/java-full-stack" />} />
          <Route path="/MernFullStack" element={<Navigate replace to="/courses/mern-stack" />} />
          <Route path="/MeanFullStack" element={<Navigate replace to="/courses/mean-stack" />} />
          <Route path="/MobileAppDevelopment" element={<Navigate replace to="/courses/mobile-app-development" />} />
          <Route path="/DataAnalysis" element={<Navigate replace to="/courses/data-analysis" />} />
          <Route path="/dataanalysis" element={<Navigate replace to="/courses/data-analysis" />} />
          <Route path="/UIUXDesigning" element={<Navigate replace to="/courses/ui-ux-design" />} />
          <Route path="/AWSCloud" element={<Navigate replace to="/courses/aws-cloud" />} />
          <Route path="/awscloud" element={<Navigate replace to="/courses/aws-cloud" />} />
          <Route path="/DevOps" element={<Navigate replace to="/courses/devops" />} />
          <Route path="/devops" element={<Navigate replace to="/courses/devops" />} />

          {/* Add other routes as needed */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
